import React from "react";
import { Label } from "semantic-ui-react";

export const ErrorLabel = <Label color="red" pointing />;
